import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Stack,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import WorkIcon from "@mui/icons-material/Work";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { api } from "../../utils/api";

const StatCard = ({ label, value, icon, color, loading }) => (
  <Card sx={{ height: "100%" }}>
    <CardContent>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Avatar sx={{ bgcolor: `${color}.main`, width: 48, height: 48 }}>
          {icon}
        </Avatar>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
          {loading ? (
            <Skeleton width={80} height={36} />
          ) : (
            <Typography variant="h4" sx={{ fontWeight: 800 }}>
              {value ?? 0}
            </Typography>
          )}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

export default function Reports() {
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/reports/summary.php");
        setSummary(res.summary || {});
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Avatar sx={{ bgcolor: "primary.main", width: 48, height: 48 }}>
          <AssessmentIcon />
        </Avatar>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 800 }}>
            Reports & Analytics
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Firm-wide performance at a glance
          </Typography>
        </Box>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Total Clients"
            value={summary.total_clients}
            icon={<PeopleIcon />}
            color="primary"
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Total Jobs"
            value={summary.total_jobs}
            icon={<WorkIcon />}
            color="warning"
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Total Revenue"
            value={`₹${summary.total_revenue || 0}`}
            icon={<CurrencyRupeeIcon />}
            color="success"
            loading={loading}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            label="Completed Tasks"
            value={summary.completed_tasks}
            icon={<TaskAltIcon />}
            color="info"
            loading={loading}
          />
        </Grid>
      </Grid>

      <Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 3 }}>
        * Detailed charts and company-wise reports coming soon.
      </Typography>
    </Box>
  );
}
